"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function NewsGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="mt-16 grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="space-y-6 animate-pulse">
            <div className="aspect-[4/5] w-full rounded-lg bg-muted/10" />
            <div className="space-y-3">
              <div className="h-6 w-3/4 rounded bg-muted/10" />
              <div className="h-4 w-1/2 rounded bg-muted/10" />
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="mt-20 text-center font-sans text-muted-foreground/60 italic">
        未能載入信件。 Failed to load letters.
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="mt-20 text-center font-sans text-muted-foreground/60 italic">
        目前沒有新的信件。 No letters found.
      </div>;
  }
  return <div className="mt-16 grid grid-cols-1 gap-x-12 gap-y-20 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <article key={post.id} data-index={i} className="group flex flex-col">
          <Link to={post.link || "#"} className="block overflow-hidden rounded-lg">
            <div className="relative aspect-[4/5] w-full overflow-hidden bg-muted/5">
              <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685908/img/letter_journal_cover.png"} alt={post.title} className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-105" loading="lazy" />
              <div className="absolute inset-0 bg-black/5 mix-blend-overlay pointer-events-none" />
              <div className="absolute inset-0 opacity-[0.02] pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685908/img/noise.png')]" />
            </div>
          </Link>

          <div className="mt-8 flex flex-col space-y-4">
            {post.date && <time className="font-sans text-[0.7rem] uppercase tracking-[0.2em] text-primary/60">
                {new Date(post.date).toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          })}
              </time>}
            
            <h3 className="font-serif text-xl font-medium leading-snug text-foreground transition-colors group-hover:text-primary/80">
              <Link to={post.link || "#"}>
                {post.title}
              </Link>
            </h3>

            <div className="font-sans text-sm leading-relaxed text-muted-foreground/80 line-clamp-2" dangerouslySetInnerHTML={{
          __html: post.excerpt || ""
        }} />

            <div className="pt-2">
              <Button asChild variant="ghost" className="h-auto p-0 text-xs font-medium tracking-widest uppercase text-foreground hover:bg-transparent group/btn">
                <Link to={post.link || "#"} className="flex items-center gap-3">
                  <span className="relative py-1 after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-0 after:bg-primary after:transition-all after:duration-500 group-hover/btn:after:w-full">
                    Read Letter
                  </span>
                  <ArrowRight className="size-3 transition-transform duration-500 group-hover/btn:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
        </article>)}
    </div>;
}
export default function RecentLetters() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="236665" id="慢遞信件集-recent-letters" className="bg-background py-24 md:py-40 text-foreground overflow-hidden">
      <div className="mx-auto max-w-screen-xl px-6 md:px-12">
        <header className="flex flex-col items-start justify-between gap-8 border-b border-primary/10 pb-12 sm:flex-row sm:items-end">
          <div className="space-y-2">
            <h2 className="font-serif text-3xl font-semibold tracking-widest text-foreground md:text-4xl">Dear Exa 文章精選</h2>
            <p className="font-serif italic text-lg text-muted-foreground/60">
              Recent Letters & Reflections
            </p>
          </div>
          
          <Link to="#" className="group flex items-center gap-3 font-sans text-xs font-medium uppercase tracking-widest text-muted-foreground transition-colors hover:text-foreground">
            <span className="relative py-1 after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-full after:bg-primary/20 after:transition-all after:duration-500 group-hover:after:bg-primary">
              View All Collection
            </span>
            <ArrowRight className="size-4 transition-transform duration-500 group-hover:translate-x-1" />
          </Link>
        </header>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3
      }}>
          <NewsGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}